import React from "react";
import { Link } from "react-router-dom";
import PageHero from "@/components/aevos/PageHero";
import { Activity, FlaskConical, ClipboardList, CalendarCheck, LineChart, Repeat } from "lucide-react";

const steps = [
  { Icon: Activity, title: "Avaliação clínica inicial", desc: "Anamnese profunda, histórico, objetivos, hábitos de vida e exames já realizados." },
  { Icon: FlaskConical, title: "Mapeamento metabólico", desc: "Bioimpedância BodyMetrix + Calorimetria Indireta + exames laboratoriais direcionados." },
  { Icon: ClipboardList, title: "Construção do protocolo", desc: "Plano nutricional, treino, sono, suplementação, terapias adjuvantes quando indicadas." },
  { Icon: CalendarCheck, title: "Execução acompanhada", desc: "Acompanhamento próximo da equipe ao longo dos 4 meses, com ajustes finos." },
  { Icon: LineChart, title: "Reavaliações periódicas", desc: "Releitura objetiva dos dados a cada ciclo para ajustar o protocolo com precisão." },
  { Icon: Repeat, title: "Continuidade evolutiva", desc: "Renovação do programa ou migração para o AEVOS 365 para manutenção contínua." },
];

const Metodo = () => {
  return (
    <div data-testid="page-metodo">
      <PageHero
        eyebrow="Método AEVOS"
        title="Não é uma consulta. É um protocolo de transformação."
        subtitle="O Método MAP — Mapear, Ajustar, Progredir — é o desenho clínico que sustenta cada paciente AEVOS por 4 meses de acompanhamento integrado."
      >
        <Link to="/contato"><span className="btn-primary">Agendar Consulta</span></Link>
      </PageHero>

      <section className="section-pad">
        <div className="aevos-container grid md:grid-cols-3 gap-5">
          {[
            { letter: "M", title: "Mapear", desc: "Entender quem você é em termos biológicos — antes de propor qualquer intervenção." },
            { letter: "A", title: "Ajustar", desc: "Construir um protocolo individual, baseado em dados e ajustado à sua rotina." },
            { letter: "P", title: "Progredir", desc: "Reavaliar, refinar, sustentar. Evoluções consistentes ao longo do tempo." },
          ].map((p) => (
            <div key={p.letter} className="aevos-card p-7">
              <div className="font-display font-bold text-5xl text-[#00C4FF]">{p.letter}</div>
              <h3 className="font-display font-semibold text-xl text-black mt-2">{p.title}</h3>
              <p className="text-sm text-[#333] mt-3">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section-pad bg-[#E6F8FF] border-y border-[#E0E0E0]">
        <div className="aevos-container">
          <div className="aevos-eyebrow mb-3">Fluxo do programa</div>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-black leading-[1.1]">Como funcionam os 4 meses do Método MAP.</h2>

          <div className="mt-10 grid md:grid-cols-2 gap-5">
            {steps.map((s, i) => (
              <div key={s.title} className="aevos-card p-6 flex gap-4">
                <div className="w-11 h-11 border border-black flex items-center justify-center flex-shrink-0">
                  <s.Icon size={20} className="text-black" />
                </div>
                <div>
                  <p className="aevos-eyebrow">Etapa {String(i+1).padStart(2,"0")}</p>
                  <h3 className="font-display font-semibold text-lg text-black mt-1">{s.title}</h3>
                  <p className="text-sm text-[#333] mt-2">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pt-20 md:pt-28 pb-10 md:pb-14 bg-black text-white text-center">
        <div className="aevos-container">
          <h2 className="font-display font-bold text-3xl md:text-5xl max-w-3xl mx-auto leading-[1.1] !text-white">
            Pronto para começar com uma <span className="text-[#00C4FF]">leitura clínica</span> precisa?
          </h2>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/contato"><span className="btn-cyan">Agendar Consulta</span></Link>
            <Link to="/planos"><span className="btn-ghost" style={{borderColor:"#FFFFFF", color:"#FFFFFF"}}>Ver Planos & Investimento</span></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Metodo;
